import { styled } from 'goober';

import { IQuizItem } from '../../types/quiz';
import { Button } from '../buttons/Button';
import { QuestionImage } from '../parts/QuestionImage';
import { QuestionText } from '../parts/QuestionText';

type Props = {
  item: IQuizItem;
  onSubmit: (value: string) => void;
};

export const InfoQuestion = ({ item, onSubmit }: Props) => {
  return (
    <Container>
      <QuestionImage item={item} info={true} />
      <QuestionText item={item} />
      <Button className="q-cta-button" onClick={onSubmit}>
        {item.cta || 'Continue'}
      </Button>
    </Container>
  );
};

const Container = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
